import { render } from "./SelfCollectionAttendance.vue?vue&type=template&id=460b493a"
import script from "./SelfCollectionAttendance.vue?vue&type=script&lang=js"
export * from "./SelfCollectionAttendance.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__